import React from 'react'
import Select from 'antd/lib/select'

class FieldSelect extends React.Component {
  searchProps = () => {
    return {
      placeholder: this.props.field.label || '',
      mode: this.props.field.multiple ? 'multiple' : 'single',
      filterOption(inputValue, option) {
        return (typeof option.props.children === 'string' && option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
      },
    }
  }

  sortOptionsAlphabetically = (a, b) => {
    const aLabel = this.props.field.options[a]
    const bLabel = this.props.field.options[b]
    if (aLabel < bLabel) return -1
    if (aLabel > bLabel) return 1
    return 0
  }
  
  renderOptions() {
    const ops = []
    const disabled = this.props.field.disabled || []
    Object.keys(this.props.field.options)
      .sort(this.sortOptionsAlphabetically)
      .forEach((op, idx) => {
        const itemDisabled = disabled.indexOf(Number(op)) > -1
        ops.push(<Select.Option key={`${op}-${idx}`} value={op} disabled={itemDisabled}>{this.props.field.options[op]}</Select.Option>)
      })    
    return ops
  }

  render() {
    return (
      <div className="gw-search__field gw-search__field-select">
        <Select {...this.searchProps()} style={{width: '100%'}} onChange={this.props.onChange} value={this.props.value}>
          {this.renderOptions()}
        </Select>
      </div>
    )
  }
}

export default FieldSelect



// WEBPACK FOOTER //
// ./src/components/search/fields/Select.js